import { PlusOutlined } from '@ant-design/icons';
import { Button, Checkbox, Modal, Radio, Space, Tooltip } from 'antd';
import React, {
  cloneElement,
  useCallback,
  useEffect,
  useRef,
  useState
} from 'react';
import TableAndFilters from './TableAndFilters';

/*
 Componente que muestra selector Multiple o Individual de una lista con la opcion de buscar.
  isMultiple : Boolean (Seleccion multiple o individual)
  columnsData: Lista de columnas de tabla
  url: Url del listado/buscador del listado
  listChecked: Lista de objeto checkeado
  setNewList: State para setear lista nueva de checks
  textButton: Texto para boton (No obligatorio)
  title: Titulo del Modal
  width = 500: Tamanho del modal
  iconButton: Icono del boton
  data: objeto
  setData: set state del objeto que se desea manipular
*/
const SelectableListModal = ({
  isMultiple,
  columnsData,
  url,
  listChecked,
  setNewList,
  setObjectList,
  textButton,
  button,
  title,
  width = 500,
  iconButton,
  data,
  setData,
  all,
  resetValue,
  notNull,
  expandable,
  placeholder,
  embedded = false,
  onRow,
  rowClassName,
  defaultFilters = null,
  extra,
  extraComponents
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [checkedList, setCheckedList] = useState([]); // Lista para checkbox
  const [checkedListObject, setCheckedListObject] = useState([]); // Lista para checkbox
  const [value, setValue] = useState(); // Value para radioButton
  const [columns, setColumns] = useState([]);
  const tableRef = useRef();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    if (isMultiple && setNewList) {
      setNewList(checkedList);
    } else if (isMultiple && setObjectList) {
      setObjectList(checkedListObject);
      if (resetValue) {
        setCheckedListObject([]);
        setCheckedList([]);
      }
    } else if (setNewList) {
      if (all) {
        setNewList([value.id]);
      } else {
        setNewList([value]);
      }
    }
    if (setData) {
      setData(data);
    }
    if (resetValue) {
      setValue();
    }

    if (extra) {
      await extra.setearArreglo(all ? [value.id] : [value], data);
    }
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    clearAll();
    setIsModalOpen(false);
  };

  const clearAll = () => {
    if (listChecked && listChecked.length > 0) {
      if (isMultiple) {
        setCheckedList(listChecked.map((item) => item.id));
      } else {
        setValue(listChecked.find((item) => item.id));
      }
    }
  };

  const onChange = useCallback(
    async (e, record) => {
      const checkedValue = record.id;
      const index = checkedList.indexOf(checkedValue);
      if (index > -1) {
        const newCheckeds = [...checkedList];
        newCheckeds.splice(index, 1);
        setCheckedList(newCheckeds);
        const newCheckedsObjects = [...checkedListObject];
        newCheckedsObjects.splice(index, 1);
        setCheckedListObject(newCheckedsObjects);
      } else {
        setCheckedList([...checkedList, checkedValue]);
        setCheckedListObject([...checkedListObject, record]);
      }
    },
    [checkedList, checkedListObject]
  );

  const onChangeRadio = useCallback(async (e, record) => {
    setValue(record);
  }, []);

  useEffect(() => {
    setColumns([
      ...columnsData,
      {
        title: 'Seleccionar',
        key: 'action',
        dataIndex: ' ',
        width: '10px',
        align: 'left',
        render: (text, record) => {
          return (
            <Space
              size="small"
              // style={{ textAlign: 'center', display: 'initial' }}
            >
              {isMultiple ? (
                <>
                  <Checkbox
                    key={record.id}
                    checked={!!checkedList.find((item) => item === record.id)}
                    onChange={(e) => onChange(e, record)}
                  />
                </>
              ) : (
                <Radio.Group
                  onChange={(e) => onChangeRadio(e, record)}
                  value={value?.id}
                >
                  <Radio key={record.id} value={record.id} />
                </Radio.Group>
              )}
            </Space>
          );
        }
      }
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkedList, value, columnsData, isMultiple, onChange, onChangeRadio]);

  useEffect(() => {
    if (listChecked) {
      setCheckedList(listChecked.map((item) => item.id));
      const radioValue = listChecked.find((item) => item.id);
      if (radioValue) {
        setValue(radioValue);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listChecked]);

  const ModalButton = () => {
    if (button) {
      const buttonCloned = cloneElement(button, {
        ...button.props,
        onClick: (event) => {
          if (button.props.onClick) {
            button.props.onClick(event);
          }
          showModal();
        }
      });
      return buttonCloned;
    }
    if (textButton) {
      return (
        <Button
          key="2"
          type="dashed"
          shape="round"
          icon={iconButton || <PlusOutlined />}
          size="large"
          onClick={showModal}
        >
          {textButton}
        </Button>
      );
    }
    return (
      <Tooltip title={title}>
        <Button
          icon={iconButton || <PlusOutlined />}
          type="text"
          size="middle"
          onClick={showModal}
          style={{ color: 'rgba(0,0,0,.45)' }}
        />
      </Tooltip>
    );
  };

  return (
    <>
      {!embedded ? (
        <>
          <ModalButton />
          <Modal
            title={title}
            open={isModalOpen}
            onOk={handleOk}
            okButtonProps={{ disabled: notNull && !isMultiple && !value }}
            onCancel={handleCancel}
            width={width}
          >
            {columns.length > 0 && (
              <TableAndFilters
                ref={tableRef}
                withGeneralFilter
                url={url}
                columns={columns}
                showTable
                hasExportar={false}
                expandable={expandable}
                tableLayout="auto"
                placeholder={placeholder}
                onRow={onRow}
                rowClassName={rowClassName}
                defaultFilters={defaultFilters}
                extra={extraComponents}
              />
            )}
          </Modal>
        </>
      ) : (
        <>
          {columns.length > 0 && (
            <>
              <TableAndFilters
                ref={tableRef}
                withGeneralFilter
                url={url}
                columns={columns}
                showTable
                hasExportar={false}
                expandable={expandable}
                tableLayout="auto"
                placeholder={placeholder}
                onRow={onRow}
                rowClassName={rowClassName}
                defaultFilters={defaultFilters}
                extra={extraComponents}
              />
              <Button key="2" type="primary" size="large" onClick={handleOk}>
                {textButton}
              </Button>
            </>
          )}
        </>
      )}
    </>
  );
};

export default SelectableListModal;
